/**
 * Algomed temasının WebApp tarafındaki entegrasyonu.
 *
 * `pnpm sync:theme` çalıştırıldığında Algomed frontend/src/theme klasörü
 * src/algomed-theme/ altına kopyalanır. Bu modül o kopyayı statik olarak import eder.
 *
 * sync:theme henüz çalıştırılmamışsa import hata verir — package.json'daki
 * `dev` ve `build` script'leri sync:theme'i otomatik çalıştırır.
 */
// @ts-ignore — JS modül, type bildirimi yok
import algomedTheme from './algomed-theme';

export const theme = algomedTheme;
export const colorMode: 'light' | 'dark' | 'system' = 'system';
